export interface TrackingIntervalOption {
  label: string;
  seconds: number;
}

export const TRACKING_INTERVAL_OPTIONS: readonly TrackingIntervalOption[] = [
  {label: '30 seconds', seconds: 30},
  {label: '45 seconds', seconds: 45},
  {label: '1 Minute', seconds: 60},
  {label: '1 Minute and 30 seconds', seconds: 90},
  {label: '2 Minutes', seconds: 120},
  {label: '5 Minutes', seconds: 300},
  {label: '10 Minutes', seconds: 600},
  {label: '20 Minutes', seconds: 1200},
  {label: '30 Minutes', seconds: 1800},
  {label: '1 Hour', seconds: 3600},
  {label: '2 Hours', seconds: 7200},
  {label: '4 Hours', seconds: 14400},
  {label: '8 Hours', seconds: 28800},
];

const TRACKING_INTERVAL_LABELS = new Map(
  TRACKING_INTERVAL_OPTIONS.map(option => [option.seconds, option.label])
);

export function formatTrackingInterval(seconds: number | undefined): string {
  if (seconds == null) {
    return "";
  }

  return TRACKING_INTERVAL_LABELS.get(seconds) ?? `${seconds} seconds`;
}
